import React, { ReactNode, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { createPortal } from 'react-dom';
import { Text, Title } from '@/components/typography';
import { ButtonGroup, Element } from '@/components/cta/Sharing/Sharing.styles';
import { whatsAppSharer } from '@/helpers/browser';
import { OffCanvas, OffCanvasBody, OffCanvasHeader } from '@/components/offcanvas';
import Tooltip from '@/components/tooltip/Tooltip';
import FormShareEmail, { FormShareEmailType } from '@/features/forms/FormShareMail/FormShareEmail';
import { useTranslations } from 'next-intl';

const ButtonShare = dynamic(() => import('@/components/button/ButtonShare/ButtonShare'), { ssr: false });

export interface SharingProps {
  title?: string;
  className?: string;
  children?: ReactNode;
  data: {
    productUuid?: FormShareEmailType['productUuid'];
    productName?: FormShareEmailType['productName'];
    permalink: string;
    title: string;
  };
  whatsApp?: boolean;
  email?: boolean;
  print?: boolean;
}

const Sharing = ({ title, data, whatsApp = true, email = true, print = true }: SharingProps) => {
  const t = useTranslations('Sharing');
  const [openCanvas, setOpenCanvas] = useState(false);
  const [mount, setMount] = useState(false);
  const toggleCanvas = () => {
    setOpenCanvas((prevState) => !prevState);
  };

  useEffect(() => {
    setMount(true);
  }, []);

  title = t('Compartilhar este Conteúdo');

  return (
    <>
      {email &&
        mount &&
        createPortal(
          <OffCanvas open={openCanvas} toggle={toggleCanvas} size="sm" scrolling={false} canvas="end">
            <OffCanvasHeader id="EmailSharer" title={t('Compartilhe por Email')} />
            <OffCanvasBody>
              <FormShareEmail productUuid={data.productUuid} productName={data.productName} />
            </OffCanvasBody>
          </OffCanvas>,
          document.body
        )}
      <Element>
        <Title as="h3" weight="semi_bold" size="md" color="secondary_500" textCase="uppercase">
          {title}
        </Title>
        <Text color="neutral_500" size="sm">
          {t('Compartilhar por')} {`${(whatsApp && 'WhatsApp') || ''}${(email && ', Email') || ''}`}
        </Text>
        <ButtonGroup>
          {whatsApp && (
            <Tooltip content={t('Compartilhe no WhatsApp')}>
              <ButtonShare
                icon="whatsapp"
                href={whatsAppSharer(data.title, data.permalink, false)}
                className="desktop"
                target="_blank"
              />
            </Tooltip>
          )}

          {email && (
            <Tooltip content={t('Compartilhe por Email')}>
              <ButtonShare
                icon="mail"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleCanvas();
                }}
              />
            </Tooltip>
          )}

          {print && (
            <Tooltip content={t('Imprimir/Salvar este conteúdo em PDF')}>
              <ButtonShare icon="print" href={`/print${data.permalink}`} target="_blank" />
            </Tooltip>
          )}
        </ButtonGroup>
      </Element>
    </>
  );
};

export default Sharing;
